import { Users01 } from "@untitledui/icons";
import { useState } from "react";
import { Button } from "@/components/base/buttons/button";
import { BulkCohortModal } from "@/pages/creator-cohorts/bulk-cohort-modal";

/**
 * "Cohort" action for the multi-select action bar: opens the bulk-assign modal
 * for the selected creators. Any selection size is supported (the server chunks
 * the assignment), so the action is bounded only by the caller's `isDisabled`.
 */
export const BulkCohortButton = ({
  creatorIds,
  onApplied,
  isDisabled,
  getCreatorLabel,
}: {
  creatorIds: string[];
  onApplied?: () => void;
  isDisabled?: boolean;
  getCreatorLabel?: (creatorId: string) => string | undefined;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button iconLeading={Users01} isDisabled={isDisabled} onClick={() => setOpen(true)}>
        Cohort
      </Button>
      <BulkCohortModal
        creatorIds={creatorIds}
        open={open}
        onOpenChange={setOpen}
        onApplied={onApplied}
        getCreatorLabel={getCreatorLabel}
      />
    </>
  );
};
